__turbopack_context__.v({
  "container": "styles-module__LyQTEq__container",
  "ctaWrapper": "styles-module__LyQTEq__ctaWrapper",
  "section": "styles-module__LyQTEq__section",
  "textWrapper": "styles-module__LyQTEq__textWrapper",
  "videoContainer": "styles-module__LyQTEq__videoContainer",
  "youtubeVideo": "styles-module__LyQTEq__youtubeVideo",
});
